import React, { useEffect, useState } from 'react';
import { Nav, TabContent, TabPane } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import TabPanePhases from '../Tab-Pane-Phases';
import TabPaneAudiences from './Tab-Pane-Audiences';
import TabPaneObjectives from './Tab-Pane-Objectives';
import TabPanePlatforms from './Tab-Pane-Platforms';
import { NavItemStyles } from './styles';
import { Kanban } from 'libs/kanban';
import { KanbanProvider } from 'hooks/useKanban';

const TabPaneMedia = ({ setStatus }) => {
  const { t: translate } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const paidMedia = new Kanban('paid-media', accountParam);
  const [activeNav, setActiveNav] = useState('1');
  const [columns, setColumns] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [audiences, setAudiences] = useState([]);
  const [platforms, setPlatforms] = useState([]);

  const fetchAccountInfo = async () => {
    const columns = await paidMedia.getColumns();
    const types = await paidMedia.getTypes();

    return { columns, types };
  };

  useEffect(() => {
    const accountInfo = fetchAccountInfo(accountParam);
    accountInfo.then((data) => {
      if (data && data.columns) {
        const columnsArray = Object.values(data.columns).sort((a, b) => a.position - b.position);
        setColumns(columnsArray);
      } else {
        setColumns([]);
      }

      if (data && data.types.objectives) {
        const objectivesArray = Object.values(data.types.objectives);
        setObjectives(objectivesArray);
      } else {
        setObjectives([]);
      }

      if (data && data.types.audiences) {
        const audiencesArray = Object.values(data.types.audiences);
        setAudiences(audiencesArray);
      } else {
        setAudiences([]);
      }

      if (data && data.types.platforms) {
        const platformsArray = Object.values(data.types.platforms);
        setPlatforms(platformsArray);
      } else {
        setPlatforms([]);
      }
    });
  }, [accountParam]);

  return (
    <div className="" style={{ display: 'flex', gap: '4.25rem' }}>
      <Nav vertical>
        <NavItemStyles active={activeNav === '1'}>
          <div onClick={() => setActiveNav('1')}>{translate('Audiences')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '2'}>
          <div onClick={() => setActiveNav('2')}>{translate('Objectives')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '3'}>
          <div onClick={() => setActiveNav('3')}>{translate('Phases')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '4'}>
          <div onClick={() => setActiveNav('4')}>{translate('Platforms')}</div>
        </NavItemStyles>
      </Nav>
      <KanbanProvider kanbanName="paid-media" accountId={accountParam}>
        <TabContent activeTab={activeNav}>
          <TabPane tabId="1">
            <TabPaneAudiences
              setStatus={setStatus}
              audiences={audiences}
              setAudiences={setAudiences}
            />
          </TabPane>
          <TabPane tabId="2">
            <TabPaneObjectives
              setStatus={setStatus}
              objectives={objectives}
              setObjectives={setObjectives}
            />
          </TabPane>
          <TabPane tabId="3">
            <TabPanePhases
              setStatus={setStatus}
              columns={columns}
              setColumns={setColumns}
              kanbanName="paid-media"
            />
          </TabPane>
          <TabPane tabId="4">
            <TabPanePlatforms setStatus={setStatus} platforms={platforms} />
          </TabPane>
        </TabContent>
      </KanbanProvider>
    </div>
  );
};

TabPaneMedia.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default TabPaneMedia;
